export class LegendItem {
  name: string;
  color: string;
  visible: boolean;

  constructor(name: string, color: string, visible: boolean) {
    this.name = name;
    this.color = color;
    this.visible = visible;
  }
}
